<template>
    <div>
        <form ref="createForm">
            <div class="row">
                <div class="col-md-6">
                    <form-group :label="__('general.country')" reference-id="country" required :error="form.errors.country">
                        <select class="form-control" name="country" id="country" v-model="form.country" required>
                            <option v-for="(country, locale) in countries" :value="locale" :selected="$locale === locale"
                                    :class="checkError(form.errors.country)">
                                {{ country }}
                            </option>
                        </select>
                    </form-group>
                </div>
                <div class="col-md-6">
                    <form-group reference-id="state" :label="__('store.state')"
                                :error="form.errors.state">
                        <input v-model="form.state" type="text" name="state" id="state" class="form-control" required
                               :class="checkError(form.errors.state)">
                    </form-group>
                </div>
            </div>
            <form-group reference-id="street1" :label="__('store.street_and_building_number')" required
                        :error="form.errors.street1">
                <input v-model="form.street1" type="text" name="street1" id="street1" class="form-control" required
                       :class="checkError(form.errors.street1)">
            </form-group>

            <div class="row">
                <div class="col-md-6">
                    <form-group reference-id="postcode" :label="__('general.postcode')" required
                                :error="form.errors.postcode">
                        <input v-model="form.postcode" type="text" name="postcode" id="postcode"
                               class="form-control" required :class="checkError(form.errors.postcode)">
                    </form-group>
                </div>
                <div class="col-md-6">
                    <form-group reference-id="city" :label="__('general.city')" required :error="form.errors.city">
                        <input v-model="form.city" type="text" name="city" id="city" class="form-control"
                               required :class="checkError(form.errors.city)">
                    </form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <form-group class="mt-3" reference-id="local_business_type" :label="__('store.type')" required
                                :error="form.errors.local_business_type">
                        <select v-model="form.local_business_type" id="local_business_type" name="local_business_type"
                                class="form-control" required
                                :class="checkError(form.errors.local_business_type)">
                            <option v-for="(localBusinessType, i) in localBusinessTypes"
                                    :value="localBusinessType.code"
                                    :selected="i === 0">
                                {{ localBusinessType.name }}
                            </option>
                        </select>
                    </form-group>
                </div>
                <div class="col-md-6">
                    <form-group class="mt-3" reference-id="tax_id" :label="__('store.tax_id')"
                                :error="form.errors.tax_id">
                        <input v-model="form.tax_id" type="text" name="tax_id" id="tax_id" class="form-control"
                               :class="checkError(form.errors.tax_id)">
                    </form-group>
                </div>
            </div>

            <local-business-type-selection ref="localBusinessTypes"/>

            <form-group reference-id="name" :label="__('store.name')" required :error="form.errors.name">
                <input v-model="form.name" type="text" name="name" id="name" class="form-control" required
                       :class="checkError(form.errors.name)">
            </form-group>

            <div class="d-flex flex-row justify-content-between">
                <form-group class="w-100 mr-5" reference-id="website"
                            :label="__('store.website') +
                            ` <span class='text-muted'>- <em>Optional</em></span>`" :error="form.errors.website">
                    <input v-model="form.website" type="url" name="website" id="website" class="form-control"
                           :class="checkError(form.errors.website)">
                    <div class="text-muted my-2" v-html="__('store.website_hint')"/>
                </form-group>
                <form-group class="w-100 mr-5" reference-id="phone"
                            :label="__('general.phone') +
                            ` <span v-if='${formSubmit === false}' class='text-muted'></span>`"
                            required :error="form.errors.phone">
                    <input v-model="form.phone" type="text" name="phone" id="phone" class="form-control"
                           :required="formSubmit" :class="checkError(form.errors.phone)">
                </form-group>
            </div>

            <form-group reference-id="description"
                        :label="__('store.description') +
                        ` <span class='text-muted'>- <em>Optional</em></span>`" :error="form.errors.description">
                <textarea v-model="form.description" class="form-control" id="description" name="description"
                          rows="6" :class="checkError(form.errors.description)"></textarea>
            </form-group>

            <div class="d-flex justify-content-end">
                <button type="button" @click="cancel" class="btn btn-outline-secondary btn-font-light mr-3">
                    {{ __('actions.abort') }}
                </button>
                <button v-if="formSubmit"
                        id="submit-store-creation-button"
                        class="btn btn-primary"
                        @click.prevent="submitForm"
                        :disabled="form.processing">
                    {{ __('actions.send') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import LocalBusinessTypeSelection from './LocalBusinessTypeSelection'
import FormGroup from './Form/FormGroup.vue'

export default {
    name: 'CreateStore',

    components: {
        FormGroup,
        LocalBusinessTypeSelection,
    },

    props: {
        localBusinessTypes: Array,
        usersPhone: String,
        formSubmit: {
            type: Boolean,
            default: true,
        },
        countries: Object,
        isAdmin: Boolean
    },

    data() {
        return {
            validated: false,
            form: this.$inertia.form({
                local_business_type: this.localBusinessTypes[0].code,
                street1: '',
                postcode: '',
                city: '',
                country: 'de',
                state: '',
                name: '',
                website: '',
                phone: this.usersPhone,
                description: '',
                tax_id: '',
                yellow_business_types: [],
            }),
        }
    },

    computed: {
        wasValidated() {
            return this.validated ? 'is-valid' : ''
        },

        getRoute() {
            return this.isAdmin ? 'admin.store.create' : 'store.create'
        }
    },

    methods: {
        cancel() {
            this.form.reset()
        },

        checkValidation() {
            this.validated = true
            let treeSelectForm = document.querySelector('.vue-treeselect__control')
            treeSelectForm.classList.add('form-control', 'is-valid', 'py-0')
            return true
        },

        submitForm() {
            if (this.checkValidation()) {
                this.addToForm()

                this.form.post(this.$route(this.getRoute), {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: () => {
                        this.cancel()
                    },
                })
            }
        },

        addToForm() {
            const inputLocalBusinessTypes = this.$refs.localBusinessTypes.$refs.hiddenInput

            if (inputLocalBusinessTypes !== undefined) {
                this.form.yellow_business_types = Array.from(inputLocalBusinessTypes).map((input) => input.value)
            }
        },

        checkError(message) {
            return message !== undefined ? 'is-invalid' : this.wasValidated
        },
    },
}
</script>
